import React, { useCallback, useEffect, useState } from "react";
import { getAllCrops } from "../../redux/Location/locationAction";
import { useDispatch, useSelector } from "react-redux";
import SearchComponent from "../../components/Search";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { fetchVendors } from "../../redux/Catalog/catalogActions";
import InfoTip from "../../components/InfoTip/infoTip";

//All Namicides_Rodenticides_Bird Repellent_Storage products

const CropCategoryTwo = ({ categoryTwoData, setCategoryTwoData }) => {
  const dispatch = useDispatch();
  const [selectedCrops, setSelectedCrops] = useState([]);
  const [cropsData, setCropsData] = useState([]);
  const [cropsSearchValue, setCropsSearchValue] = useState("");
  const [duplicatedCropsData, setDuplicatedCropsData] = useState([]);
  const [isToggleCrops, setIsToggleCrops] = useState(false);
  const { vendors } = useSelector((state) => state.catalog);

  const [isVendorOpen, setIsVendorOpen] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState({});

  const handleCrops = (data) => {
    if (selectedCrops.some((item) => Number(data.id) === Number(item.id))) {
      const updated = selectedCrops.filter(
        (each) => Number(each.id) !== Number(data.id)
      );
      setSelectedCrops(updated);
      // After removal, update targetCrops
      setCategoryTwoData((prev) => {
        return {
          ...prev,
          target_crops: updated.map((c) => c.id),
        };
      });
      return;
    }
    const updated = [...selectedCrops, data];
    setSelectedCrops(updated);
    setCategoryTwoData((prev) => {
      return {
        ...prev,
        target_crops: updated.map((c) => c.id),
      };
    });
  };

  const handleSearchCropsChange = useCallback(
    (e) => {
      let val = e.target.value;
      setCropsSearchValue(val);
      let data = duplicatedCropsData;

      let filteredData = data.filter((crops) =>
        crops?.name?.toLowerCase().includes(val?.toLowerCase())
      );
      setCropsData(filteredData);
    },
    [duplicatedCropsData, setCropsSearchValue]
  );

  const handleCropClick = () => {
    dispatch(getAllCrops()).then((res) => {
      setCropsData(res?.payload?.data);
      setDuplicatedCropsData(res?.payload?.data);
    });
    setIsToggleCrops(!isToggleCrops);
  };

  const handleSelectedVendor = (data) => {
    setSelectedVendor({
      name: data.name,
      id: data.id,
    });
    setIsVendorOpen(false);
    setCategoryTwoData((prev) => {
      return {
        ...prev,
        vendor: data,
      };
    });
  };

  useEffect(() => {
    dispatch(fetchVendors());
  }, [dispatch]);

  useEffect(() => {
    // Set selected vendor based on categoryTwoData.vendor
    if (categoryTwoData.vendor && vendors?.length > 0) {
      const vendor = vendors?.find(
        (v) =>
          v.name === categoryTwoData.vendor.name ||
          v.id === categoryTwoData.vendor.id
      );
      if (vendor) {
        setSelectedVendor(vendor);
      }
    }
  }, [categoryTwoData.vendor, vendors]);

  useEffect(() => {
    // Set selected crops based on categoryTwoData.target_crops
    if (
      categoryTwoData.target_crops &&
      categoryTwoData.target_crops?.length > 0
    ) {
      // Check if target_crops contains objects with id/name or just IDs
      if (typeof categoryTwoData.target_crops[0] === "object") {
        // target_crops contains objects like [{id: 13, name: "Groundnuts"}, ...]
        setSelectedCrops(categoryTwoData.target_crops);
        // Also fetch all crops for the dropdown
        dispatch(getAllCrops()).then((res) => {
          setCropsData(res?.payload?.data || []);
          setDuplicatedCropsData(res?.payload?.data || []);
        });
      } else {
        // target_crops contains just IDs like [13, 18, 29, 46]
        dispatch(getAllCrops()).then((res) => {
          const allCrops = res?.payload?.data || [];
          const selectedCropsFromData = allCrops.filter((crop) =>
            categoryTwoData.target_crops.includes(crop.id)
          );
          setSelectedCrops(selectedCropsFromData);
          setCropsData(allCrops);
          setDuplicatedCropsData(allCrops);
        });
      }
    }
  }, [dispatch, categoryTwoData.target_crops]);

  return (
    <div>
      {" "}
      <div className="relative   rounded-lg bg-white h-fit border border-[#E1E6E1] mt-3">
        <div className="flex flex-col">
          <div className="border-b border-b-[#E1E6E1] px-4 py-3 flex items-center gap-1">
            <p className="text-[#4B564D] font-semibold text-sm ">
              Product Details
            </p>
          </div>

          <div className="flex flex-col gap-4 px-4 py-3">
            {/* VENDOR */}
            <div className="relative w-full">
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Vendor
                </p>
              </div>
              <div
                onClick={() => setIsVendorOpen(!isVendorOpen)}
                className="flex justify-between items-center px-[16px] border border-[#96A397] rounded-[8px] h-[44px] w-full cursor-pointer"
              >
                <p className="font-[500] text-sm leading-[20px] capitalize text-[#344335]">
                  {selectedVendor.name || "Select Vendor"}
                </p>
                <ExpandMore
                  className="text-[#ABB6AC] cursor-pointer"
                  style={{ fontSize: "18px" }}
                />
              </div>

              {isVendorOpen && (
                <div className="absolute right-0  w-full rounded-lg  bg-white padding-[8px] mt-[1%] border cursor-pointer py-[8px] mb-[50px] z-20 max-h-[250px] overflow-y-scroll shadow-md">
                  {vendors?.map((data, index) => {
                    return (
                      <p
                        className="py-[12px] px-[16px] text-sm font-medium capitalize leading-5 hover:bg-[#EDF7EE]"
                        key={index}
                        onClick={() => handleSelectedVendor(data)}
                      >
                        {data.name}
                      </p>
                    );
                  })}
                </div>
              )}
            </div>

            <div>
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Product Class
                </p>
              </div>
              <input
                type="text"
                placeholder="Product Class"
                onChange={(event) =>
                  setCategoryTwoData((prev) => {
                    return {
                      ...prev,
                      product_class: event.target.value,
                    };
                  })
                }
                value={categoryTwoData.product_class}
                className="outline-none border border-[#96A397] w-full h-[44px] rounded-lg px-3 py-4 placeholder:text-[#96A397] text-sm font-medium leading-5"
              />
            </div>

            <div>
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Dose Rate
                </p>
                <InfoTip text="The recommended quantity of product to apply per unit of land or crop." />
              </div>
              <input
                type="text"
                placeholder="Dose Rate"
                onChange={(event) =>
                  setCategoryTwoData((prev) => {
                    return {
                      ...prev,
                      dose_rate: event.target.value,
                    };
                  })
                }
                value={categoryTwoData.dose_rate}
                className="outline-none border border-[#96A397] w-full h-[44px] rounded-lg px-3 py-4 placeholder:text-[#96A397] text-sm font-medium leading-5"
              />
            </div>

            <div>
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Target Crops
                </p>
                <InfoTip text="The crops the product is designed or approved to be used on." />
              </div>
              <div
                className="flex items-center gap-5 cursor-pointer justify-between outline-0 h-[44px] truncate bg-white rounded-[8px] border border-[#96A397] py-3  px-[14px] w-full font-mdium text-sm leading-5 text-[#96A397]"
                onClick={handleCropClick}
              >
                <div className="">
                  {selectedCrops?.length > 0 ? (
                    <div className="flex items-center gap-2 h-fit flex-wrap">
                      <p>
                        {selectedCrops.length > 4
                          ? `${selectedCrops
                              .slice(0, 4)
                              .map((data) => data.name)
                              .join(", ")}+${selectedCrops?.length - 4}`
                          : selectedCrops?.map((data) => data.name)?.join(", ")}
                      </p>
                    </div>
                  ) : (
                    <>
                      <p> Select Crops</p>
                    </>
                  )}
                </div>

                {isToggleCrops ? (
                  <ExpandLess
                    className="text-[#ABB6AC] cursor-pointer"
                    style={{ fontSize: "18px" }}
                  />
                ) : (
                  <ExpandMore
                    className="text-[#ABB6AC] cursor-pointer"
                    style={{ fontSize: "18px" }}
                  />
                )}
              </div>

              {isToggleCrops && (
                <div
                  className="absolute rounded-[8px] p-[8px] w-[94%] mr-9 bg-white z-20 max-h-[250px] overflow-y-scroll "
                  style={{
                    boxShadow:
                      "0px 0px 1px rgba(0, 0, 0, 0.25), 0px 16px 32px rgba(0, 0, 0, 0.08",
                  }}
                >
                  <div className="">
                    <SearchComponent
                      placeholder="Search..."
                      searchValue={cropsSearchValue}
                      handleChange={handleSearchCropsChange}
                    />
                  </div>
                  {cropsData.map((data, index) => {
                    return (
                      <div
                        key={index}
                        className="px-4 py-3 hover:bg-[#EDF7EE] cursor-pointer flex gap-4"
                      >
                        <input
                          type="checkbox"
                          checked={selectedCrops.some(
                            (item) => Number(item.id) === Number(data.id)
                          )}
                          onChange={(event) => {
                            handleCrops(data, event);
                          }}
                          className="accent-primary h-[14px] w-[14px] rounded-[2px] mt-1"
                        />
                        <p className="font-medium text-sm leading-5 text-[#344335]">
                          {data.name}
                        </p>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div>
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Mixing and Application
                </p>
              </div>
              <textarea
                type="text"
                placeholder="Application Time"
                onChange={(event) =>
                  setCategoryTwoData((prev) => {
                    return {
                      ...prev,
                      mixing_and_application: event.target.value,
                    };
                  })
                }
                value={categoryTwoData.mixing_and_application}
                className="outline-none border border-[#96A397] resize-none w-full h-[134px] rounded-lg px-3 py-4 placeholder:text-[#96A397] text-sm font-medium leading-5"
              />
            </div>

            <div>
              <div className="flex items-center gap-1 pb-1">
                <p className="text-[#344335] font-normal text-sm leading-[18px]">
                  Active ingredient(s)
                </p>
              </div>
              <textarea
                type="text"
                placeholder="Active ingredient(s)"
                onChange={(event) =>
                  setCategoryTwoData((prev) => {
                    return {
                      ...prev,
                      active_ingredient: event.target.value,
                    };
                  })
                }
                value={categoryTwoData.active_ingredient}
                className="outline-none border border-[#96A397] resize-none w-full h-[134px] rounded-lg px-3 py-4 placeholder:text-[#96A397] text-sm font-medium leading-5"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CropCategoryTwo;
